import React from 'react';

import ComponentType from '../../types/Component';
import ErrorIcon from '../ui/icons/Error';

import styles from './styles.module.scss';

type WarningBlockProps = {
	icon?: JSX.Element;
};

const WarningBlock: ComponentType<WarningBlockProps> = ({ icon, children }) => {
	return (
		<div className={styles.warningBlock}>
			<div className={styles.warningBlockIcon}>{icon ? icon : <ErrorIcon />}</div>
			<div className={styles.warningBlockText}>{children}</div>
		</div>
	);
};

export default WarningBlock;
